export const BASE_API_URL = process.env.BASE_API_URL;
export const BASE_COOKIE_DOMAIN = process.env.BASE_COOKIE_DOMAIN;


import {redirect} from "./redirect"

const version = new Date().getTime();
export default {
  version,
  components: [
    {path: '~/components/common/'}
  ],
  modern: process.env.NODE_ENV === 'production',
  server: {
    port: 3000,
    host: '0.0.0.0'
  },

  head: {
    title: 'linza.ru',
    htmlAttrs: {
      lang: 'ru'
    },
    meta: [
      {charset: 'utf-8'},
      // { name: 'viewport', content: 'width=1000, initial-scale=1' },
      // {name: 'google-site-verification', content: '3mwMSDTr3drC7W5tGAqyNVfo01AO5UfsU0yGn3Qe0NE'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1, viewport-fit=cover, maximum-scale=1, user-scalable=no'},
      // {name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'},
      {hid: 'metadescription', name: 'description', content: ''},
      {name: "msapplication-TileColor", content: "#ffffff"},
      {name: "theme-color", content: "#ffffff"},
      {name: "yandex-verification", content: "43b60ca86a8a6654"},
    ],

    link: [
      {rel: 'icon', type: 'image/x-icon', href: '/favicon.ico'},
      {rel: "apple-touch-icon", sizes: "180x180", href: "/apple-touch-icon.png"},
      {rel: "icon", type: "image/png", sizes: "32x32", href: "/favicon-32x32.png"},
      {rel: "icon", type: "image/png", sizes: "16x16", href: "/favicon-16x16.png"},
      {rel: "mask-icon", href: "/safari-pinned-tab.svg", color: "#a72681"},
      {rel: "preload", as: "image", href: '/logo-full.svg', type: "image/svg+xml"},
    ],

    script: [
      {type: 'text/javascript', body: true, src: '/js/sourcebuster.min.js', async: true},
      {type: 'text/javascript', body: true, src: '/js/carrotquest.js', async: true},
      {type: 'text/javascript', body: true, src: '/js/vk-retargeting.js', async: true},
    ]
  },
  // Global CSS: https://go.nuxtjs.dev/config-css
  css: [
    '~/assets/scss/main.scss'
  ],
  // styleResources: {
  //   scss: [require.resolve('./assets/scss/theme/_varibles.scss', { paths: [process.cwd()] })],
  // },
  // Plugins to run before rendering page: https://go.nuxtjs.dev/config-plugins
  plugins: [
    {src: '~/plugins/VueAwesomeSwiper.js'},
    {src: '~/plugins/Vuelidate.js'},
    {src: '~/plugins/smooth-scroll', ssr: false},
    {src: '~plugins/vue-js-modal.js', ssr: true},
    '~plugins/vue-mask.js',
    '~plugins/case-words.js',
    '~plugins/number-format.js',
    '~plugins/custom-notification.js',
    '~plugins/vue-cool-lightbox.js',
    '~plugins/nuxt-router-hack-plugin.js',
    '~plugins/vue-lazyload.js',
    '~plugins/get-cookies-opt.js',
    '~plugins/yandex-commerce.js',
    '~plugins/device.js',
    '~plugins/vk-goal-wr.js',
    // '~plugins/vue-yandex-maps.js',

  ],

  // Modules for dev and build (recommended): https://go.nuxtjs.dev/config-modules
  buildModules: [
    // 'nuxt-delay-hydration',
    '@nuxtjs/pwa',
    // https://go.nuxtjs.dev/typescript
    '@nuxt/typescript-build',
    // https://go.nuxtjs.dev/tailwindcss
    '@nuxtjs/tailwindcss',
    // '@nuxtjs/style-resources',

  ],

  // delayHydration: {
  //   mode: 'mount'
  // },
  render: {
    bundleRenderer: {
      shouldPreload: (file, type) => {
        return ['font', 'script', 'style'].includes(type)
      }
    }
  },

  image: {
    providers: {
      imageProvider: {
        name: 'imageProvider',
        provider: `${__dirname}/providers/imageProvider`,
        options: {
          modifiers: {
            format: 'webp',
          },
          baseURL: process.env.BASE_API_URL + 'storage/image/'
        }
      }
    },
    provider: 'imageProvider'
  },
  // Modules: https://go.nuxtjs.dev/config-modules
  modules: [
    ['@nuxtjs/redirect-module', {statusCode: 301}],
    '@nuxtjs/pwa',
    '@nuxtjs/moment',
    'nuxt-ssr-cache',
    'vue-scrollto/nuxt',
    '@nuxtjs/auth',
    '@nuxt/image',
    'cookie-universal-nuxt',
    '@nuxtjs/style-resources',
    '@nuxtjs/toast',
    '@nuxtjs/axios',
    '@forked-prs/nuxt-infinite-scroll-module',
    '@nuxtjs/sentry',
    'nuxt-user-agent',
    'nuxt-clipboard2',
    ['~/node_modules/sitis-nuxt/lib', {
      baseUrl: process.env.BASE_API_URL,
      // cmsRoot: 'cms' - default
    }],

    // Yandex Metrika
    [
      '@rkaliev/nuxtjs-yandex-metrika',
      {
        // debug: true,

        id: 17708848,
        webvisor: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        ecommerce: "dataLayer",
        disabled: Boolean(process.env.ENVIRONMENT !== 'production'),
      },
    ],

    // reCAPTCHA
    ['@nuxtjs/recaptcha', {
      language: "ru",
      siteKey: "6LfyyRsiAAAAADahHVUoyI4_aRUkd3wwJb77o2fR",
      version: 2
    }],
  ],

  redirect,

  // Build Configuration: https://go.nuxtjs.dev/config-build
  publicRuntimeConfig: {
    axios: {
      baseUrl: process.env.BASE_API_URL
    },
  },
  moment: {
    locales: ['ru'],
  },

  // '@nuxtjs/toast' config
  toast: {
    position: 'top-right',
    duration: 3000
  },
  loading: {
    color: 'orange',
    height: '5px',
    failedColor: 'red',
    duration: 5000,
    continuous: true,
  },

  // Build Configuration: https://go.nuxtjs.dev/config-build
  build: {
    extend(config, {isClient}) {
      // Extend only webpack config for client-bundle
      if (isClient) {
        config.devtool = 'source-map';
      }

      config.resolve.alias['vue'] = 'vue/dist/vue.common'
    },
    extractCSS: true,
    filenames: {
      img: ({isDev}) => isDev ? '[path][name].[ext]?v=' + version : 'img/[name].[contenthash:7].[ext]?v=' + version,
      app: ({
              isDev,
              isModern
            }) => isDev ? `[name]${isModern ? '.modern' : ''}.js?v=` + version : `[contenthash:7]${isModern ? '.modern' : ''}.js?v=` + version,
      chunk: ({
                isDev,
                isModern
              }) => isDev ? `[name]${isModern ? '.modern' : ''}.js?v=` + version : `[contenthash:7]${isModern ? '.modern' : ''}.js?v=` + version,
      css: ({isDev}) => isDev ? '[name].css?v=' + version : 'css/[name][contenthash:7].css?v=' + version,
      video: ({isDev}) => isDev ? '[path][name].[ext]?v=' + version : 'videos/[name].[contenthash:7].[ext]?v=' + version
    },
    babel: {
      plugins: [
        // https://stackoverflow.com/questions/68663581/latest-nuxt-v2-15-7-install-with-babel-loose-option-warnings
        ['@babel/plugin-proposal-private-property-in-object', {loose: true}],
      ],
    },
    typescript: {
      typeCheck: {
        memoryLimit: 2048
      }
    }
  },

  cache: {
    // if you're serving multiple host names (with differing
    // results) from the same server, set this option to true.
    // (cache keys will be prefixed by your host name)
    // if your server is behind a reverse-proxy, please use
    // express or whatever else that uses 'X-Forwarded-Host'
    // header field to provide req.hostname (actual host name)
    useHostPrefix: false,
    pages: [
      // these are prefixes of pages that need to be cached
      // if you want to cache all pages, just include '/'
      '/',
    ],

    key(route, context) {
      // custom function to return cache key, when used previous
      // properties (useHostPrefix, pages) are ignored. return
      // falsy value to bypass the cache
    },

    store: {
      type: 'memory',

      // maximum number of pages to store in memory
      // if limit is reached, least recently used page
      // is removed.
      max: 100,

      // number of seconds to store this page in cache
      ttl: 60,
    },
  },


  router: {
    trailingSlash: false,
    extendRoutes(routes, resolve) {

      // Страница специалиста
      routes.unshift({
        path: '/specialists/:id',
        components: {
          default: resolve(__dirname, 'pages/specialists/index.vue')
        },
        chunkNames: {
          default: 'specialist-item'
        }
      });

      // Страница услуги
      routes.unshift({
        path: '/uslugi/:slug/:service',
        components: {
          default: resolve(__dirname, 'pages/uslugi/_slug/index.vue')
        },
        chunkNames: {
          default: 'uslugi-slug-service'
        }
      });

      // Страница успешной оплаты
      routes.unshift({
        path: '/order/success/:hash',
        components: {
          default: resolve(__dirname, 'pages/checkout/success.vue')
        },
        chunkNames: {
          default: 'order-success-hash'
        }
      });

      // Страница информации о заказе
      routes.unshift({
        path: '/order/:hash',
        components: {
          default: resolve(__dirname, 'pages/checkout/process/_hash.vue')
        },
        chunkNames: {
          default: 'order-hash'
        }
      });


      routes = routes.sort((a, b) => {
        if (a.path < b.path) {
          return 1
        }
        if (a.path > b.path) {
          return -1
        }
        return 0
      });
    }
  },

  pwa: {
    manifest: {
      name: 'Очки для Вас',
      description: 'хорошо видеть — хорошо выглядеть',
      lang: 'ru',
      theme_color: '#a72681',
      useWebmanifestExtension: false
    }
  },
  env: {
    // изображения для услуг в записях на прием
    isShowImgAppointment: process.env.IS_SHOW_IMG_APPOINTMENT,

    // API ключ яндекс карты
    yandexMapApiKey: process.env.YANDEX_MAP_API_KEY || "",

    // API ключ dadata
    dadataApiKey: process.env.DADATA_API_KEY || "",

    // Включена ли авторизация в кабинете MyAcuvue
    myAcuvueIncluded: Boolean(process.env.MY_ACUVUE_INCLUDED === "true") || false,

    productionNodeEnv: Boolean(process.env.ENVIRONMENT === "production"),

    baseApiUrl: process.env.BASE_API_URL,
    baseCookieDomain: process.env.BASE_COOKIE_DOMAIN,

    showClassesCaseOnCartAdded: process.env.SHOW_GLASSES_CASE_ON_CART_ADDED,

    // API ключ для VK
    vkPixelCode: process.env.VK_PIXEL_CODE,

    cmsPageZapisInformation: process.env.CMS_PAGE_ZAPIS_INFORMATION,

    yandexMetrikaId: process.env.YANDEX_METRIKA_ID,

    subdomainForJJ: process.env.SUBDOMAIN_FOR_JJ,
    visibleConfirmCity: process.env.VISIBLE_CONFIRM_CITY,
    homePageForSubdomainForJJ: process.env.HOME_PAGE_FOR_SUBDOMAIN_FOR_JJ,


    signUpSelectionsRegions: process.env.SIGN_UP_SELECTIONS_REGIONS,
    isShowCalendarButton: process.env.IS_SHOW_CALENDAR_BUTTON,
    certificatProductId: process.env.CERTIFICAT_PRODUCT_ID || "9910",

    productPageTopCmsPageId: process?.env?.PRODUCT_PAGE_TOP_CMS_PAGE_ID || "",
    productPageBottomCmsPageId: process?.env?.PRODUCT_PAGE_BOTTOM_CMS_PAGE_ID || "",

    cartVisibleRelatedProducts: process?.env?.CART_VISIBLE_RELATED_PRODUCTS || "0",

    customPeriodAvailableDays: process?.env?.CUSTOM_PERIOD_AVAILABLE_DAYS || "0",
    customPeriodAvailableProductsIds: process?.env?.CUSTOM_PERIOD_AVAILABLE_PRODUCTS_IDS

  },

  sentry: {
    dsn: 'https://791846b409784d01af0f16757c4ac7c1@o272399.ingest.sentry.io/5944011',
    lazy: true,
    config: {},
    publishRelease: {
      authToken: '9c965b5a331343f38512cb6135a2ce613bfa39bcfb724379998efe2b46eba789',
      org: 'sitis',
      project: 'linzaru',
      setCommits: {
        auto: true
      }
    },
    disabled: true
  }
}
